import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Header from './Header';
import UnderwriterOwner from '../enums/UnderwriterOwner';
import AppStorage from '../Storage/Storage';

export const HeaderWrapper = () => {
  const location = useLocation();
  const [isLangSelectorShown, setIsLangSelectorShown] = useState(
    !(
      window.location.pathname.includes('questionnaire') &&
      UnderwriterOwner.TAF_MRA !== AppStorage.getInstance().getUnderwriterOwner
    ),
  );

  const checkIfPathWasChanged = (): void => {
    let showSelector = true;
    const underwriterOwner = AppStorage.getInstance().getUnderwriterOwner;
    if (
      window.location.pathname.includes('questionnaire') &&
      (!underwriterOwner ||
        underwriterOwner === UnderwriterOwner.IPT_MAGNUM ||
        underwriterOwner === UnderwriterOwner.ZEL_AURA)
    ) {
      showSelector = false;
    } else {
      const supportedLocales = localStorage.getItem('locales')?.split(',');

      if (supportedLocales) {
        showSelector = supportedLocales.length > 1;
      }
    }
    setIsLangSelectorShown(showSelector);
  };

  const { healthDeclarationId = '' } = useParams();

  const navigate = useNavigate();
  const redirectHome = () => {
    // block redirect to home after declaration was signed
    if (location.pathname.includes('signed')) return;
    navigate(`/${healthDeclarationId}/instructions`);
  };

  useEffect(() => {
    checkIfPathWasChanged();
  }, [location]);

  return (
    <Header
      redirectHome={redirectHome}
      isLangSelectorShown={isLangSelectorShown}
    />
  );
};
